"use client";

import Image from "next/image";

import Marquee from "~/componentsDS/Marquee";
import Overline from "~/componentsDS/Typography/Overline";
import useFlag from "~/hooks/useFlag";
import { FEATURED_IN } from "~/constants/flags";
import { cn } from "~/lib/utils";
import type { Logo } from "./data";
import { type FeaturedInVariant, getFeaturedInVariant, LOGOS_BY_VARIANT } from "./variants";

type Props = {
    speed?: number;
    className?: string;
    variant?: FeaturedInVariant;
    labelClassName?: string;
    logosClassName?: string;
    logoClassName?: string;
    logos?: readonly Logo[];
}

const FeaturedIn = ({
    speed = 0.5,
    className,
    variant,
    labelClassName,
    logosClassName,
    logoClassName,
    logos: logosOverride,
}: Props) => {
    const flagVariant = getFeaturedInVariant(useFlag(FEATURED_IN));
    const resolvedVariant = variant ?? flagVariant;
    const logos = logosOverride ?? LOGOS_BY_VARIANT[resolvedVariant];

    const isOnDarkBackground = resolvedVariant === "white";

    return (
        <div className={cn(isOnDarkBackground && "bg-gray500 py-6", className)}>
            <Overline
                weight="500"
                className={cn(
                    "mb-3 text-center",
                    isOnDarkBackground ? "text-pureWhite" : "text-primary500",
                    labelClassName
                )}
            >
                featured in
            </Overline>

            <Marquee speed={speed} direction="right">
                <div
                    className={cn(
                        "flex shrink-0 items-center gap-8 px-4 md:gap-[120px] md:px-10",
                        logosClassName
                    )}
                >
                    {logos.map(({src, alt, width, height}) => (
                        <div key={src} className="flex shrink-0 items-center">
                            <Image
                                src={src}
                                alt={alt}
                                width={width}
                                height={height}
                                sizes={`${width}px`}
                                className={cn(
                                    "object-cover object-center",
                                    logoClassName
                                )}
                            />
                        </div>
                    ))}
                </div>
            </Marquee>
        </div>
    )
};

export default FeaturedIn;
